// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__1OYNg","questionsAndAnswersContainer":"styles_questionsAndAnswersContainer__2pR-t"};